import { render, staticRenderFns } from "./LicensesMenu.vue?vue&type=template&id=bcddcfc2"
import script from "./LicensesMenu.vue?vue&type=script&lang=js"
export * from "./LicensesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports